@if (!showReadonlyView) {
  <div>
    <div class="form-group">
      <label class="text-gray-dark flex"
        >{{ title! | translate }}&nbsp;
        @if (tooltip !== null) {
          <i-feather name="info" [ngbTooltip]="tooltip | translate"></i-feather>
        }
      </label>
      <input
        type="text"
        [disabled]="disabled"
        (change)="onChange(value!)"
        placeholder="example@example.com"
        class="form-control"
        [ngClass]="{ 'input-error': validationErrors.length > 0 || emailAddressIsDuplicate }"
        [(ngModel)]="value"
        (focusout)="isValid()"
      />
      @if (validationErrors.length > 0) {
        <div class="invalid-field">
          @for (error of validationErrors; track error) {
            <span> {{ error | translate }} <br /> </span>
          }
        </div>
      }
    </div>
  </div>
}

@if (showReadonlyView) {
  <div>
    <div class="form-group read-only">
      <label class="text-gray-dark flex"
        >{{ title! | translate }}&nbsp;
        @if (readonlyTooltip !== null) {
          <i-feather name="info" [ngbTooltip]="readonlyTooltip | translate"> </i-feather>
        }
      </label>
      <div class="input-group">{{ value }}</div>
    </div>
  </div>
}
